<template>
    <div class="nranking">
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
            :breadcrumb="{ props: { routes } }"
        />

        <div class="nranking-detail">
            <a-card>
                <div>
                    <div class="search  push-search">
                        <div class="left">
                            <label for="">采购需求：</label>
                            <a-range-picker @change="onChange" :locale="locale" class="nranking-date"/>
                            <a-button type="primary">查询</a-button>
                        </div>
                        <div class="right">
                            <a href="">
                                <a-button type="primary">ECMS助手(桌面工具)</a-button>
                            </a>
                            <router-link to="/thesaurus">
                                <a-button type="primary">词库管理</a-button>
                            </router-link>
                        </div>
                    </div>
                    <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                    >

                    <span slot="action">
                        <a href=""><a-icon type="file-search"/>查看</a>
                    </span>
                    </a-table>

                </div>
            </a-card>
        </div>


    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import router from "@/router/index"
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '关键词数',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '查询页数',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '在新词数',
    key: 'tags',
    dataIndex: 'tags',
  },
  {
    title: '查询进度',
    key: 'url',
    dataIndex: 'url',

  },
  {
    title: '开始时间',
    key: 'ipaddress',
    dataIndex: 'ipaddress',

  },
  {
    title: '结束时间',
    key: 'money',
    dataIndex: 'money',

  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: '钢化玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'未读',
    money:'26',
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: '阳台玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'已读',
    money:'3.2',
  },
];

export default {
    data(){
        return{
            data,
            locale,
            columns,
            pagination: {},
            loading: false,
            routes: [
                {breadcrumbName: '首页'},
                {breadcrumbName: '排名查询'},
                {breadcrumbName: '自然排名'},
            ],
        }
    },
    methods:{
        onChange(date, dateString) {
            console.log(date, dateString);
        },
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/ranking/nranking.vue